



































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { AxiosError } from "axios";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import UserDiskSpace from "@/components/user/UserDiskSpace.vue";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import {
  bookkeepingModule,
  learningDocumentsModule,
  studentDocumentModule
} from "@/plugins/modules-detect";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models";
import company, { CompanyListParams } from "@/getinfo-api/company";
import { CompaniesList as ICompaniesList } from "@/api/models/companies-list";
import UserAvatar from "@/components/user/UserAvatar.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";

import { DiskList as IDiskList } from "@/api-v2/files/models";
import Doughnut from "@/components/companies/Doughnut.vue";

import { fileApi } from "@/getinfo-api";
import UserShareAccess from "@/components/user/UserShareAccess.vue";
import UserFilesFromDocuments from "@/components/user/UserFilesFromDocuments.vue";

@Component({
  components: {
    UserFilesFromDocuments,
    UserShareAccess,
    Doughnut,
    CFileManager,
    TextField,
    CBlock,
    UserAvatar,
    SelectEntity,
    UserDiskSpace
  }
})
export default class UserProfileView extends Vue {
  @Prop() user!: IUser;
  @Prop() documentInfo!: IUserDocumentInfo;
  userCompanies?: ICompaniesList;
  employeeWithCompany: any = [];
  userDisk!: any;

  data() {
    return {
      userDisk: undefined,
      userCompanies: undefined
    };
  }
  get documentModule() {
    return bookkeepingModule() || learningDocumentsModule();
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  getFileSpace() {
    fileApi.DiskApi.my(0, 200).then((res: { data: IDiskList }) => {
      this.userDisk = res.data.items;
    });
  }

  get isStudentDocumentModule() {
    return studentDocumentModule();
  }

  getRoles(role: string) {
    let formattedRole = "";
    if (role === "content_manager")
      formattedRole = this.$tc(this.$translate.Teacher);
    if (role === "learning_request_manager")
      formattedRole = this.$tc(this.$translate.LearningRequestManager);
    if (role === "document_manager")
      formattedRole = this.$tc(this.$translate.Accountant);
    return formattedRole;
  }

  getRolesInCompany() {
    this.userCompanies?.companies?.forEach(el => {
      const param: EmployeeListParams = {
        id: el.id,
        userIds: [this.user.id]
      };
      employee(param).then((response: { data: IEmployeesList2 }) => {
        const obj = {
          company: el,
          employee: response.data.employees[0]
        };
        this.employeeWithCompany.push(obj);
      });
    });
  }

  getCompany() {
    let params: CompanyListParams = {
      employeesIds: [this.user.id]
    };
    company(params)
      .then((res: { data: ICompaniesList }) => {
        this.userCompanies = res.data;
        if (this.userCompanies?.companies.length) {
          this.getRolesInCompany();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  gender() {
    switch (this.user?.gender) {
      case 1:
        return this.$tc(this.$translate.Male);
      case 0:
        return this.$tc(this.$translate.Female);
      default:
        return this.$tc(this.$translate.NotSelected);
    }
  }

  mounted() {
    this.getFileSpace();
    this.getRolesInCompany();
    this.getCompany();
  }
  get root() {
    return isRoot();
  }
}
